import { string } from 'prop-types';

const MapsIcon = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <title>map-icon</title>
      <g fill="none">
        <g>
          <g transform="translate(-70 -270) translate(70 270)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <path
                d="M21 18.15l-4.667 1.483V5.849L21 4.367V18.15zM9.667 4.368l4.666 1.482v13.784L9.667 18.15V4.367zM3 5.849l4.667-1.482V18.15L3 19.633V5.849zm19.591-3.656c-.258-.188-.591-.242-.894-.146l-6.364 2.02-6.363-2.02c-.025-.008-.05 0-.074-.005-.077-.018-.151-.016-.229-.017-.078 0-.151-.001-.228.017-.025.005-.05-.003-.075.005L1.697 4.165c-.415.132-.697.517-.697.953V21c0 .319.152.619.409.807.174.127.381.193.591.193.102 0 .204-.016.303-.047l6.364-2.021 6.356 2.019h.001l.006.002c.099.03.201.047.303.047.102 0 .204-.016.303-.047l.006-.002h.001l6.66-2.115c.415-.132.697-.518.697-.954V3c0-.32-.152-.62-.409-.807z"
                transform="translate(8 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

MapsIcon.propTypes = {
  className: string
};

MapsIcon.defaultProps = {
  className: ''
};

export default MapsIcon;
